/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReasonCode } from '../../models/reason-code';

export interface CreateReasonCode$Params {
  body: ReasonCode;
}

export function createReasonCode(
  http: HttpClient,
  rootUrl: string,
  params: CreateReasonCode$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<ReasonCode>> {
  const rb = new RequestBuilder(rootUrl, createReasonCode.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReasonCode>;
    })
  );
}

createReasonCode.PATH = '/admin/reason-codes';
